import { StarIcon } from "lucide-react";
import { Review } from "types/general.interface";
import { getTimeFromDate } from "utills/helper";

interface Props {
  review: Review;
}
export default function ReviewCard({ review }: Props) {
  return (
    <div>
      <div className="flex items-center justify-between my-6">
        <div className="flex items-center  gap-4 ">
          <div className=" flex flex-col  gap-2 ">
            <span>{`${review?.reviewBy?.firstName} ${review?.reviewBy?.lastName}`}</span>

            <span className=" flex items-center ">
              {[1, 2, 3, 4, 5].map((star) => (
                <StarIcon
                  key={star}
                  color={review.rating >= star ? "#FFA836" : "#D4D3D3"}
                />
              ))}
              {review.rating}.0
            </span>
          </div>
        </div>
        <div>
          <p className=" text-muted font-body text-sm leading-4 font-medium">
            {" "}
            Posted: {getTimeFromDate(review.createdAt)}
          </p>
        </div>
      </div>
      <p className=" font-body font-normal leading-4 text-sm text-body">
        {review.review}
      </p>
    </div>
  );
}
